import React, { Dispatch, MutableRefObject, useEffect, useRef, useState } from 'react'
import { CloseIcon } from '../iconSet/IconSet'
import { ASWAdminData, CUSAdminData, EarlyWarningTypes, FLWAdminData, GUSAdminData, HRWAdminData, HWNAdminData, LIGAdminData, LSWAdminData, MWAAdminData, NTWAdminData, TWAdminData } from './CreateWarningTypes';
import Feature, { FeatureLike } from 'ol/Feature';
import { SelectItemTypes } from '../../CommonTypes';
import { Geometry } from 'ol/geom';
import Style from 'ol/style/Style';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import { useTheme } from '../../context/ThemeContext';
import { data } from 'react-router-dom';
import Text from 'ol/style/Text'

export type AdminData = 
  | { type: 'MWA'; data: MWAAdminData }
  | { type: 'FLW'; data: FLWAdminData }
  | { type: 'HRW'; data: HRWAdminData }
  | { type: 'HWN'; data: HWNAdminData }
  | { type: 'LIG'; data: LIGAdminData }
  | { type: 'LSW'; data: LSWAdminData }
  | { type: 'NTW'; data: NTWAdminData }
  | { type: 'ASW'; data: ASWAdminData }
  | { type: 'TW'; data: TWAdminData }
  | { type: 'CUS'; data: CUSAdminData }
  | { type: 'GUS'; data: GUSAdminData }

type MapSelectorPolygonPopupTypes = {
    type: EarlyWarningTypes;
    setPopupStatus: Dispatch<React.SetStateAction<boolean>>;
    data: Feature<Geometry>[];
    onDeselect: (feature: Feature<Geometry>[]) => void;
    setData: MutableRefObject<AdminData[]>;
    startDate: string;
    endDate: string;
    tableData: AdminData[];
    setTableData: Dispatch<React.SetStateAction<AdminData[]>>
}

export const ALERT_COLORS = {
    yellow: '#ffff00',
    amber: '#ffbf00',
    red: '#ff0000',
    high: '#ff0000',
    moderate: '#ffbf00',
    low: '#00ff00',
    sight: '#ffbf00',
    white: '#fff',
    green: '#00ff00',
    gray: '#5f5f5fff'
}

const MapSelectorPolygonPopup = (props: MapSelectorPolygonPopupTypes) => {

    const theme = useTheme()
    // HRW ---------------------------------------------------
    const [hrwPrevAlertLevel, setHRWPrevAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [hrwNewAlertLevel, setHRWNewAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [hrwLightingRiskLevel, setHRWLightingRiskLevel] = useState<SelectItemTypes[]>([
        {value: 'low', name: 'low'},
        {value: 'moderate', name: 'moderate'},
        {value: 'high', name: 'high'}
    ])

    const hrwPervAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const hrwNewAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const hrwRainfallValueRef = useRef<HTMLInputElement | null>(null)
    const hrwLightingRiskLevelRef = useRef<HTMLSelectElement | null>(null)
    const hrwStartDateRef = useRef<HTMLInputElement | null>(null)
    const hrwEndDateRef = useRef<HTMLInputElement | null>(null)

    // LSW ---------------------------------------------------------------------
    const [lswPrevAlertLevel, setLSWPrevAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [lswNewAlertLevel, setLSWNewAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [lswLightingRiskLevel, setLSWLightingRiskLevel] = useState<SelectItemTypes[]>([
        {value: 'low', name: 'low'},
        {value: 'moderate', name: 'moderate'},
        {value: 'high', name: 'high'}
    ])

    const lswPervAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const lswNewAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const lswRainfallValueRef = useRef<HTMLInputElement | null>(null)
    const lswLightingRiskLevelRef = useRef<HTMLSelectElement | null>(null)
    const lswStartDateRef = useRef<HTMLInputElement | null>(null)
    const lswEndDateRef = useRef<HTMLInputElement | null>(null)

    // FLW ---------------------------------------------------
    const [flwPrevAlertLevel, setFLWPrevAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [flwNewAlertLevel, setFLWNewAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [flwLightingRiskLevel, setFLWLightingRiskLevel] = useState<SelectItemTypes[]>([
        {value: 'low', name: 'low'},
        {value: 'moderate', name: 'moderate'},
        {value: 'high', name: 'high'}
    ])

    const flwPervAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const flwNewAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const flwRainfallValueRef = useRef<HTMLInputElement | null>(null)
    const flwLightingRiskLevelRef = useRef<HTMLSelectElement | null>(null)
    const flwStartDateRef = useRef<HTMLInputElement | null>(null)
    const flwEndDateRef = useRef<HTMLInputElement | null>(null)

    // LIG ------------------------------------------------------------------------
    const [ligLightningRiskLevel, setLIGLightningRiskLevel] = useState<SelectItemTypes[]>([
        {name: "Low", value: "low"},
        {name: "Moderate", value: "moderate"},
        {name: "High", value: "high"},
    ])

    const [ligPreviousAlertLevel, setLIGPreviousAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    const [ligNewAlertLevel, setLIGNewAlertLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    const ligPervAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const ligNewAlertLevelRef = useRef<HTMLSelectElement | null>(null)
    const ligLightingRiskLevelRef = useRef<HTMLSelectElement | null>(null)
    const ligStartDateRef = useRef<HTMLInputElement | null>(null)
    const ligEndDateRef = useRef<HTMLInputElement | null>(null)

    // HWN --------------------------------------------------------------------
    const [hwnSeverityLevel, setHWNSeverityLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [hwnLightning, setHWNLightning] = useState<SelectItemTypes[]>([
        {value: 'low', name: 'low'},
        {value: 'moderate', name: 'moderate'},
        {value: 'high', name: 'high'}
    ])

    const hwnMinWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const hwnMaxWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const hwnPrevSeverityLevelRef = useRef<HTMLSelectElement | null>(null)
    const hwnSeverityLevelRef = useRef<HTMLSelectElement | null>(null)
    const hwnLightningRef = useRef<HTMLSelectElement | null>(null)
    const hwnStartDateRef = useRef<HTMLInputElement | null>(null)
    const hwnEndDateRef = useRef<HTMLInputElement | null>(null)

    

    // MWA ------------------------------------------------------------------
    const [mwaSeaCondition, setMWASeaCondition] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    const [mwaThunderstorm, setMWAThunderstorm] = useState<SelectItemTypes[]>([
        {name: "Low", value: "low"},
        {name: "Moderate", value: "moderate"},
        {name: "High", value: "high"},
    ])

    const mwaMinWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const mwaMaxWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const mwaMinWaveHeightRef = useRef<HTMLInputElement | null>(null)
    const mwaMaxWaveHeightRef = useRef<HTMLInputElement | null>(null)
    const mwaPrevSeaConditionRef = useRef<HTMLSelectElement | null>(null)
    const mwaSeaConditionRef = useRef<HTMLSelectElement | null>(null)
    const mwaThunderstormRef = useRef<HTMLSelectElement | null>(null)
    const mwaStartDateRef = useRef<HTMLInputElement | null>(null)
    const mwaEndDateRef = useRef<HTMLInputElement | null>(null)

    const ntwStartDateRef = useRef<HTMLInputElement | null>(null)
    const ntwEndDateRef = useRef<HTMLInputElement | null>(null)

    // ASW
    const aswStartDateRef = useRef<HTMLInputElement | null>(null)
    const aswEndDateRef = useRef<HTMLInputElement | null>(null)
    const aswNewAlertRef = useRef<HTMLInputElement | null>(null)
    const aswPrevAlertRef = useRef<HTMLInputElement | null>(null)

    // TW ------------------------------------------------------------------
    const [twSeaCondition, setTWSeaCondition] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {name: "Yellow", value: "yellow"},
        //{name: "Amber", value: "amber"},
        {name: "Orange", value: "amber"},
        {name: "Red", value: "red"},
    ])

    const [twThunderstorm, setTWThunderstorm] = useState<SelectItemTypes[]>([
        {name: "Low", value: "low"},
        {name: "Moderate", value: "moderate"},
        {name: "High", value: "high"},
    ])

    const twMinWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const twMaxWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const twMinWaveHeightRef = useRef<HTMLInputElement | null>(null)
    const twMaxWaveHeightRef = useRef<HTMLInputElement | null>(null)
    const twPrevSeaConditionRef = useRef<HTMLSelectElement | null>(null)
    const twSeaConditionRef = useRef<HTMLSelectElement | null>(null)
    const twThunderstormRef = useRef<HTMLSelectElement | null>(null)
    const twStartDateRef = useRef<HTMLInputElement | null>(null)
    const twEndDateRef = useRef<HTMLInputElement | null>(null)

    // CUS --------------------------------------------------------------------
    const [cusSeverityLevel, setCUSSeverityLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        //{value: 'amber', name: 'Amber'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const cusPrevSeverityLevelRef = useRef<HTMLSelectElement | null>(null)
    const cusSeverityLevelRef = useRef<HTMLSelectElement | null>(null)
    const cusStartDateRef = useRef<HTMLInputElement | null>(null)
    const cusEndDateRef = useRef<HTMLInputElement | null>(null)

        // GUS --------------------------------------------------------------------
    const [gusSeverityLevel, setGUSSeverityLevel] = useState<SelectItemTypes[]>([
        {name: "White", value: "white"},
        {value: 'yellow', name: 'Yellow'},
        {name: "Orange", value: "amber"},
        {value: 'red', name: 'Red'}
    ])

    const [gusLightning, setGUSLightning] = useState<SelectItemTypes[]>([
        {name: "Low", value: "low"},
        {name: "Moderate", value: "moderate"},
        {name: "High", value: "high"},
    ])

    const gusMinWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const gusMaxWindSpeedRef = useRef<HTMLInputElement | null>(null)
    const gusPrevSeverityLevelRef = useRef<HTMLSelectElement | null>(null)
    const gusSeverityLevelRef = useRef<HTMLSelectElement | null>(null)
    const gusLightningRef = useRef<HTMLSelectElement | null>(null)
    const gusStartDateRef = useRef<HTMLInputElement | null>(null)
    const gusEndDateRef = useRef<HTMLInputElement | null>(null)


    // Check duplicate data availability
    const isDuplicate = (setData: any[], type: string, code: string): boolean => {
        return setData.some(item => item.type === type && item.data.code === code);
    }

    const getThemeColors = (): { background: string; stroke: string; defaultFill: string } => {
        switch (theme.theme) {
            case 'dark':
                return {
                    background: '#1a1a1a',
                    stroke: 'black',
                    defaultFill: '#EEE'
                }
            case 'light':
                return {
                    background: '#f5f5f5',
                    stroke: 'black',
                    defaultFill: '#EEE'
                }
            case 'colorful':
            default:
                return {
                    background: '#e8f4f8',
                    stroke: 'black',
                    defaultFill: '#EEE'
                }
        }
    }
    
    const getAlertColor = (alertLevel: string): string => {
        const key = alertLevel.toLowerCase() as keyof typeof ALERT_COLORS;
        return ALERT_COLORS[key] || getThemeColors().defaultFill
    }

    // Handle click set button
    const handleSaveButtonClick = (type: EarlyWarningTypes) => {
        if (!props.data) return

        // Get the selected alert level value
        let alertLevel = ''
        switch (props.type) {
            case 'HRW':
                alertLevel = hrwNewAlertLevelRef.current?.value || ''
                break
            case 'LSW':
                alertLevel = lswNewAlertLevelRef.current?.value || ''
                break
            case 'FLW':
                alertLevel = flwNewAlertLevelRef.current?.value || ''
                break
            case 'LIG':
                alertLevel = ligNewAlertLevelRef.current?.value || ''
                break
            case 'HWN':
                alertLevel = hwnSeverityLevelRef.current?.value || ''
                break
            case 'MWA':
                alertLevel = mwaSeaConditionRef.current?.value || ''
                break
            case 'TW':
                alertLevel = twSeaConditionRef.current?.value || ''
                break
            case 'CUS':
                alertLevel = cusSeverityLevelRef.current?.value || ''
                break
            case 'GUS':
                alertLevel = gusSeverityLevelRef.current?.value || ''
                break
        }

        const feature = props.data as Feature<Geometry>[]
        const color = getAlertColor(alertLevel)
        
        feature.forEach(item => {
            item.setStyle(new Style({
                fill: new Fill({ color }),
                stroke: new Stroke({ color: 'red', width: 3 }),
            }))
        })
        // Apply style (without persisting to feature properties)
        
        feature.forEach(item => {
            switch (type){
                case 'HRW':
                    if(hrwPervAlertLevelRef.current && hrwNewAlertLevelRef.current && hrwRainfallValueRef.current && hrwLightingRiskLevelRef.current && hrwStartDateRef.current && hrwEndDateRef.current) 
                    {
                        const prevAlert = hrwPervAlertLevelRef.current.value;
                        //const newAlert = hrwNewAlertLevelRef.current.value;
                        const rainfall = hrwRainfallValueRef.current.valueAsNumber;
                        const lightningRisk = hrwLightingRiskLevelRef.current.value;
                        const startDate = hrwStartDateRef.current.value;
                        const endDate = hrwEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || item.getProperties()['ADM_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "HRW")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "HRW" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                previousAlertLevel: prevAlert,
                                                newAlertLevel: alertLevel,
                                                rainfall: rainfall,
                                                lightingRiskLevel: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                RAINFALL: rainfall,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "HRW",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    previousAlertLevel: hrwPervAlertLevelRef.current.value,
                                    newAlertLevel: hrwNewAlertLevelRef.current.value,
                                    rainfall: hrwRainfallValueRef.current.valueAsNumber,
                                    lightingRiskLevel: hrwLightingRiskLevelRef.current.value,
                                    startDate: hrwStartDateRef.current.value,
                                    endDate: hrwEndDateRef.current.value
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                RAINFALL: rainfall,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'FLW':
                    if (flwPervAlertLevelRef.current && flwNewAlertLevelRef.current && flwRainfallValueRef.current && flwLightingRiskLevelRef.current && flwStartDateRef.current && flwEndDateRef.current) 
                    {
                        const prevAlert = flwPervAlertLevelRef.current.value;
                        //const newAlert = flwNewAlertLevelRef.current.value;
                        const rainfall = flwRainfallValueRef.current.valueAsNumber;
                        const lightningRisk = flwLightingRiskLevelRef.current.value;
                        const startDate = flwStartDateRef.current.value;
                        const endDate = flwEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "FLW")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "FLW" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                previousAlertLevel: prevAlert,
                                                newAlertLevel: alertLevel,
                                                rainfall: rainfall,
                                                lightingRiskLevel: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                RAINFALL: rainfall,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "FLW",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    previousAlertLevel: flwPervAlertLevelRef.current.value,
                                    newAlertLevel: flwNewAlertLevelRef.current.value,
                                    rainfall: flwRainfallValueRef.current.valueAsNumber,
                                    lightingRiskLevel: flwLightingRiskLevelRef.current.value,
                                    startDate: flwStartDateRef.current.value,
                                    endDate: flwEndDateRef.current.value
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                RAINFALL: rainfall,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'MWA':
                    if (mwaMinWindSpeedRef.current && mwaMaxWindSpeedRef.current && mwaMinWaveHeightRef.current && mwaMaxWaveHeightRef.current && mwaSeaConditionRef.current && mwaThunderstormRef.current && mwaStartDateRef.current && mwaEndDateRef.current && mwaPrevSeaConditionRef.current) 
                    {
                        const minWind = mwaMinWindSpeedRef.current.valueAsNumber;
                        const maxWind = mwaMaxWindSpeedRef.current.valueAsNumber;
                        const minWave = mwaMinWaveHeightRef.current.valueAsNumber;
                        const maxWave = mwaMaxWaveHeightRef.current.valueAsNumber;
                        const prevSeaCondition = mwaPrevSeaConditionRef.current.value
                        //const seaCondition = mwaSeaConditionRef.current.value;
                        const lightningRisk = mwaThunderstormRef.current.value;
                        const startDate = mwaStartDateRef.current.value;
                        const endDate = mwaEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || item.getProperties()['ADM_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || item.getProperties()['ADM_EN'] || ''
    
                        if (isAvailableInData(code, "MWA")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "MWA" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                minWindSpeed: maxWind,
                                                maxWindSpeed: maxWind,
                                                maxWave: maxWave,
                                                minWave: minWave,
                                                prevSeaCondition: prevSeaCondition,
                                                seaCondition: alertLevel,
                                                thunderstorm: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                MIN_WAVE_HEIGHT: minWave,
                                MAX_WAVE_HEIGHT: maxWave,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEA_CONDITION: prevSeaCondition,
                                SEA_CONDITION: alertLevel,
                                LIGHTNING: lightningRisk,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "MWA",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    minWindSpeed: maxWind,
                                    maxWindSpeed: maxWind,
                                    maxWave: maxWave,
                                    minWave: minWave,
                                    prevSeaCondition: prevSeaCondition,
                                    seaCondition: alertLevel,
                                    thunderstorm: lightningRisk,
                                    startDate: startDate,
                                    endDate: endDate
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                MIN_WAVE_HEIGHT: minWave,
                                MAX_WAVE_HEIGHT: maxWave,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEA_CONDITION: prevSeaCondition,
                                SEA_CONDITION: alertLevel,
                                LIGHTNING: lightningRisk,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'HWN':
                    if (hwnMinWindSpeedRef.current && hwnMaxWindSpeedRef.current && hwnSeverityLevelRef.current && hwnLightningRef.current && hwnStartDateRef.current && hwnEndDateRef.current && hwnPrevSeverityLevelRef.current) {
                        const minWind = hwnMinWindSpeedRef.current.valueAsNumber;
                        const maxWind = hwnMaxWindSpeedRef.current.valueAsNumber;
                        const prevSeverity = hwnPrevSeverityLevelRef.current.value
                        //const severity = hwnSeverityLevelRef.current.value;
                        const lightningRisk = hwnLightningRef.current.value;
                        const startDate = hwnStartDateRef.current.value;
                        const endDate = hwnEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "HWN")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "HWN" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                minWindSpeed: minWind,
                                                maxWindSpeed: maxWind,
                                                prevSeverity: prevSeverity,
                                                severity: alertLevel,
                                                lightning: lightningRisk,
                                                //lightingRiskLevel: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEVERITY: prevSeverity,
                                SEVERITY: alertLevel,
                                LIGHTNING: lightningRisk,
                                //LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "HWN",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    minWindSpeed: hwnMinWindSpeedRef.current.valueAsNumber,
                                    maxWindSpeed: hwnMaxWindSpeedRef.current.valueAsNumber,
                                    lightingRiskLevel: hwnLightningRef.current.value,
                                    prevSeverity: hwnPrevSeverityLevelRef.current.value,
                                    severity: hwnSeverityLevelRef.current.value,
                                    startDate: startDate,
                                    endDate: endDate
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEVERITY: prevSeverity,
                                SEVERITY: alertLevel,
                                LIGHTNING: lightningRisk,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'LIG':
                    
                    if (ligPervAlertLevelRef.current && ligNewAlertLevelRef.current && ligLightingRiskLevelRef.current && ligStartDateRef.current && ligEndDateRef.current) 
                    {
                        const prevAlert = ligPervAlertLevelRef.current.value;
                        //const newAlert = ligNewAlertLevelRef.current.value;
                        const lightningRisk = ligLightingRiskLevelRef.current.value;
                        const startDate = ligStartDateRef.current.value;
                        const endDate = ligEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "LIG")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "LIG" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                previousAlertLevel: prevAlert,
                                                newAlertLevel: alertLevel,
                                                lightingRiskLevel: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                LIGHTNING_RISK: lightningRisk,
                                LIGHTNING: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "LIG",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    previousAlertLevel: ligPervAlertLevelRef.current.value,
                                    newAlertLevel: ligNewAlertLevelRef.current.value,
                                    lightingRiskLevel: ligLightingRiskLevelRef.current.value,
                                    startDate: ligStartDateRef.current.value,
                                    endDate: ligEndDateRef.current.value
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                LIGHTNING_RISK: lightningRisk,
                                LIGHTNING: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    
                    break
                case 'LSW':
                    if (props.setData && lswPervAlertLevelRef.current && lswNewAlertLevelRef.current && lswRainfallValueRef.current && lswLightingRiskLevelRef.current && lswStartDateRef.current && lswEndDateRef.current) 
                    {
                        const prevAlert = lswPervAlertLevelRef.current.value;
                        //const newAlert = lswNewAlertLevelRef.current.value;
                        const rainfall = lswRainfallValueRef.current.valueAsNumber;
                        const lightningRisk = lswLightingRiskLevelRef.current.value;
                        const startDate = lswStartDateRef.current.value;
                        const endDate = lswEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "LSW")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "LSW" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                previousAlertLevel: prevAlert,
                                                newAlertLevel: alertLevel,
                                                rainfall: rainfall,
                                                lightingRiskLevel: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                RAINFALL: rainfall,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "LSW",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    previousAlertLevel: lswPervAlertLevelRef.current.value,
                                    newAlertLevel: alertLevel,
                                    rainfall: lswRainfallValueRef.current.valueAsNumber,
                                    lightingRiskLevel: lswLightingRiskLevelRef.current.value,
                                    startDate: lswStartDateRef.current.value,
                                    endDate: lswEndDateRef.current.value
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: alertLevel,
                                RAINFALL: rainfall,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'NTW':
                    /* if (props.setData && ntwStartDateRef.current && ntwEndDateRef.current) {
                        const ntwAdminData: NTWAdminData = {
                            name: feature.getProperties()['ADM3_EN'] || feature.getProperties()['ADM2_EN'] || feature.getProperties()['ADM1_EN'] || feature.getProperties()['ADM0_EN'] || '',
                            code: feature.getProperties()['ADM3_PCODE'] || feature.getProperties()['ADM2_PCODE'] || feature.getProperties()['ADM1_PCODE'] || feature.getProperties()['ADM0_PCODE'] || '',
                            adminName: feature.getProperties()['ADMIN_NAME'],
                            adminLevel: feature.getProperties()['ADMIN_LEVEL'],
                            startDate: ntwStartDateRef.current.value,
                            endDate: ntwEndDateRef.current.value
                        }
    
                        if (!isDuplicate(props.setData.current, 'NTW', ntwAdminData.code)) {
                            props.setData.current.push({type: 'NTW', data: ntwAdminData})
                            feature.setProperties({
                                TYPE: type,
                                START_DATE: ntwStartDateRef.current.value,
                                END_DATE: ntwEndDateRef.current.value
                            })
                        }
                    } */
                    break
                case 'ASW':
                    /* if (props.setData && aswStartDateRef.current && aswEndDateRef.current && aswPrevAlertRef.current && aswNewAlertRef.current) {
                        const prevAlert = aswPrevAlertRef.current.value;
                        const newAlert = aswNewAlertRef.current.value;
                        const startDate = aswStartDateRef.current.value;
                        const endDate = aswEndDateRef.current.value;
    
                        const code = feature.getProperties()['ADM3_PCODE'] || feature.getProperties()['ADM2_PCODE'] || feature.getProperties()['ADM1_PCODE'] || feature.getProperties()['ADM0_PCODE'] || ''
                        const name = feature.getProperties()['ADM3_EN'] || feature.getProperties()['ADM2_EN'] || feature.getProperties()['ADM1_EN'] || feature.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "ASW")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "ASW" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                previousAlertLevel: prevAlert,
                                                newAlertLevel: newAlert,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            feature.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: newAlert,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "ASW",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: feature.getProperties()['ADMIN_LEVEL'],
                                    isSelected: true,
                                    previousAlertLevel: aswPrevAlertRef.current.value,
                                    newAlertLevel: aswNewAlertRef.current.value,
                                    startData: aswStartDateRef.current.value,
                                    endDate: aswEndDateRef.current.value
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            feature.setProperties({
                                TYPE: type,
                                PREV_ALERT: prevAlert,
                                NEW_ALERT: newAlert,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    } */
                    break
                case 'TW':
                    if (twMinWindSpeedRef.current && twMaxWindSpeedRef.current && twMinWaveHeightRef.current && twMaxWaveHeightRef.current && twSeaConditionRef.current && twThunderstormRef.current && twStartDateRef.current && twEndDateRef.current && twPrevSeaConditionRef.current) 
                    {
                        const minWind = twMinWindSpeedRef.current.valueAsNumber;
                        const maxWind = twMaxWindSpeedRef.current.valueAsNumber;
                        const minWave = twMinWaveHeightRef.current.valueAsNumber;
                        const maxWave = twMaxWaveHeightRef.current.valueAsNumber;
                        const prevSeaCondition = twPrevSeaConditionRef.current.value
                        const seaCondition = twSeaConditionRef.current.value;
                        const lightningRisk = twThunderstormRef.current.value;
                        const startDate = twStartDateRef.current.value;
                        const endDate = twEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "TW")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "TW" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                minWindSpeed: maxWind,
                                                maxWindSpeed: maxWind,
                                                maxWave: maxWave,
                                                minWave: minWave,
                                                prevSeaCondition: prevSeaCondition,
                                                seaCondition: seaCondition,
                                                thunderstorm: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                MIN_WAVE_HEIGHT: minWave,
                                MAX_WAVE_HEIGHT: maxWave,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEA_CONDITION: prevSeaCondition,
                                SEA_CONDITION: seaCondition,
                                LIGHTNING: lightningRisk,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "TW",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    minWindSpeed: maxWind,
                                    maxWindSpeed: maxWind,
                                    maxWave: maxWave,
                                    minWave: minWave,
                                    prevSeaCondition: prevSeaCondition,
                                    seaCondition: seaCondition,
                                    thunderstorm: lightningRisk,
                                    startDate: startDate,
                                    endDate: endDate
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                MIN_WAVE_HEIGHT: minWave,
                                MAX_WAVE_HEIGHT: maxWave,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEA_CONDITION: prevSeaCondition,
                                SEA_CONDITION: seaCondition,
                                LIGHTNING: lightningRisk,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'CUS': 
                    if(cusPrevSeverityLevelRef.current && cusSeverityLevelRef.current && cusStartDateRef.current && cusEndDateRef.current) 
                    {
                        const prevAlert = cusPrevSeverityLevelRef.current.value
                        const newAlert = cusSeverityLevelRef.current.value
                        const startDate = cusStartDateRef.current.value;
                        const endDate = cusEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "CUS")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "CUS" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                prevSeverity: prevAlert,
                                                severity: newAlert,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                PREV_SEVERITY: prevAlert,
                                SEVERITY: newAlert,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "CUS",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    prevSeverity: cusPrevSeverityLevelRef.current.value,
                                    severity: cusSeverityLevelRef.current.value,
                                    startDate: cusStartDateRef.current.value,
                                    endDate: cusEndDateRef.current.value
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
    
                            item.setProperties({
                                TYPE: type,
                                PREV_SEVERITY: prevAlert,
                                SEVERITY: newAlert,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
                case 'GUS':
                    if (gusMinWindSpeedRef.current && gusMaxWindSpeedRef.current && gusSeverityLevelRef.current && gusLightningRef.current && gusStartDateRef.current && gusEndDateRef.current && gusPrevSeverityLevelRef.current) {
                        const minWind = gusMinWindSpeedRef.current.valueAsNumber;
                        const maxWind = gusMaxWindSpeedRef.current.valueAsNumber;
                        const prevSeverity = gusPrevSeverityLevelRef.current.value
                        //const severity = gusSeverityLevelRef.current.value;
                        const lightningRisk = gusLightningRef.current.value;
                        const startDate = gusStartDateRef.current.value;
                        const endDate = gusEndDateRef.current.value;
    
                        const code = item.getProperties()['ADM3_PCODE'] || item.getProperties()['ADM2_PCODE'] || item.getProperties()['ADM1_PCODE'] || item.getProperties()['ADM0_PCODE'] || ''
                        const name = item.getProperties()['ADM3_EN'] || item.getProperties()['ADM2_EN'] || item.getProperties()['ADM1_EN'] || item.getProperties()['ADM0_EN'] || ''
    
                        if (isAvailableInData(code, "GUS")) {
                            // Update existing item
                            props.setTableData(prevState =>
                                prevState.map(item =>
                                    item.type === "GUS" && item.data.code === code
                                        ? {
                                            ...item,
                                            data: {
                                                ...item.data,
                                                isSelected: true,
                                                minWindSpeed: minWind,
                                                maxWindSpeed: maxWind,
                                                prevSeverity: prevSeverity,
                                                severity: alertLevel,
                                                lightning: lightningRisk,
                                                //lightingRiskLevel: lightningRisk,
                                                startDate: startDate,
                                                endDate: endDate
                                            }
                                        }
                                        : item
                                )
                            )
    
                            item.setProperties({
                                TYPE: type,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEVERITY: prevSeverity,
                                SEVERITY: alertLevel,
                                LIGHTNING: lightningRisk,
                                //LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        } else {
                            // Add new item
                            const newItem: AdminData = {
                                type: "GUS",
                                data: {
                                    code: code,
                                    name: name,
                                    adminName: name,
                                    adminLevel: item.getProperties()['ADMIN_LEVEL'] === 0 ? 'country' : item.getProperties()['ADMIN_LEVEL'] === 1 ? 'atoll' : item.getProperties()['ADMIN_LEVEL'] === 2 ? 'island' : item.getProperties()['admin_level'] === 4 ? 'sea' : 'N/A',
                                    isSelected: true,
                                    minWindSpeed: gusMinWindSpeedRef.current.valueAsNumber,
                                    maxWindSpeed: gusMaxWindSpeedRef.current.valueAsNumber,
                                    lightingRiskLevel: gusLightningRef.current.value,
                                    prevSeverity: gusPrevSeverityLevelRef.current.value,
                                    severity: gusSeverityLevelRef.current.value,
                                    startDate: startDate,
                                    endDate: endDate
                                },
                            };
    
                            props.setTableData(prevState => [...prevState, newItem])
                            item.setProperties({
                                TYPE: type,
                                MIN_WIND: minWind,
                                MAX_WIND: maxWind,
                                PREV_SEVERITY: prevSeverity,
                                SEVERITY: alertLevel,
                                LIGHTNING: lightningRisk,
                                LIGHTNING_RISK: lightningRisk,
                                START_DATE: startDate,
                                END_DATE: endDate
                            })
                        }
                    }
                    break
            }
        })
        
        
        props.setPopupStatus(false)
    }

    const isAvailableInData = (code: string, type: EarlyWarningTypes): boolean => {
        switch (type){
            case "LSW":
                return props.tableData.some((item): item is {type: "LSW"; data: LSWAdminData} => 
                    item.type === "LSW" && item.data.code === code
                )
            case "FLW": 
                return props.tableData.some((item): item is {type: "FLW"; data: FLWAdminData} => 
                    item.type === "FLW" && item.data.code === code
                )
            case "HRW": 
                return props.tableData.some((item): item is {type: "HRW"; data: HRWAdminData} => 
                    item.type === "HRW" && item.data.code === code
                )
            case "HWN": 
                return props.tableData.some((item): item is {type: "HWN"; data: HWNAdminData} => 
                    item.type === "HWN" && item.data.code === code
                )
            case "LIG": 
                return props.tableData.some((item): item is {type: "LIG"; data: LIGAdminData} => 
                    item.type === "LIG" && item.data.code === code
                )
            case "MWA": 
                return props.tableData.some((item): item is {type: "MWA"; data: MWAAdminData} => 
                    item.type === "MWA" && item.data.code === code
                )
            case "TW": 
                return props.tableData.some((item): item is {type: "TW"; data: TWAdminData} => 
                    item.type === "TW" && item.data.code === code
                )
            case "CUS": 
                return props.tableData.some((item): item is {type: "CUS"; data: CUSAdminData} => 
                    item.type === "CUS" && item.data.code === code
                )
            case "GUS": 
                return props.tableData.some((item): item is {type: "GUS"; data: GUSAdminData} => 
                    item.type === "GUS" && item.data.code === code
                )
            default:
                return false
        }
    }

    // Handle close button
    const handleClose = () => {

        if (props.data === null) return
        //props.onDeselect(props.data)

        /* const feature = props.data as Feature<Geometry>
        feature.setProperties({
            TYPE: '',
            PREV_ALERT: '',
            NEW_ALERT: '',
            RAINFALL: '',
            LIGHTNING_RISK: '',
            MIN_WIND: '',
            MAX_WIND: '',
            SEVERITY: '',
            LIGHTNING: '',
            START_DATE: '',
            END_DATE: ''
        }) */

        props.setPopupStatus(false)
    }

    const handleReset = () => {
        props.onDeselect(props.data as Feature<Geometry>[])

        /* const feature = props.data as Feature<Geometry>
        feature.setProperties({
            TYPE: '',
            PREV_ALERT: '',
            NEW_ALERT: '',
            RAINFALL: '',
            LIGHTNING_RISK: '',
            MIN_WIND: '',
            MAX_WIND: '',
            SEVERITY: '',
            LIGHTNING: '',
            START_DATE: '',
            END_DATE: ''
        }) */
        
        props.setPopupStatus(false)
    }

    useEffect(() => {
        const feature = props.data as Feature<Geometry>[]

        //console.log("properties: ", feature.getProperties())

        feature.forEach(item => {
            switch (props.type){
                case 'HRW':
                    if(props.setData && hrwPervAlertLevelRef.current && hrwNewAlertLevelRef.current && hrwRainfallValueRef.current && hrwLightingRiskLevelRef.current && hrwStartDateRef.current && hrwEndDateRef.current) {
                        
                        if (item.getProperties()['PREV_ALERT']) {
                            hrwPervAlertLevelRef.current.value = item.getProperties()['PREV_ALERT']
                        }
                        if (item.getProperties()['NEW_ALERT']) {
                            hrwNewAlertLevelRef.current.value = item.getProperties()['NEW_ALERT']
                        }
                        if (item.getProperties()['RAINFALL']) {
                            hrwRainfallValueRef.current.value = item.getProperties()['RAINFALL']
                        }
                        if (item.getProperties()['LIGHTNING_RISK']) {
                            hrwLightingRiskLevelRef.current.value = item.getProperties()['LIGHTNING_RISK']
                        }
                        if (item.getProperties()['START_DATE']) {
                            hrwStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            hrwEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'FLW':
                    if (flwPervAlertLevelRef.current && flwNewAlertLevelRef.current && flwRainfallValueRef.current && flwLightingRiskLevelRef.current && flwStartDateRef.current && flwEndDateRef.current) {
                        if (item.getProperties()['PREV_ALERT']) {
                            flwPervAlertLevelRef.current.value = item.getProperties()['PREV_ALERT']
                        }
                        if (item.getProperties()['NEW_ALERT']) {
                            flwNewAlertLevelRef.current.value = item.getProperties()['NEW_ALERT']
                        }
                        if (item.getProperties()['RAINFALL']) {
                            flwRainfallValueRef.current.value = item.getProperties()['RAINFALL']
                        }
                        if (item.getProperties()['LIGHTNING_RISK']) {
                            flwLightingRiskLevelRef.current.value = item.getProperties()['LIGHTNING_RISK']
                        }
                        if (item.getProperties()['START_DATE']) {
                            flwStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            flwEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'MWA':
                    if (props.setData && mwaMinWindSpeedRef.current && mwaMaxWindSpeedRef.current && mwaMinWaveHeightRef.current && mwaMaxWaveHeightRef.current && mwaSeaConditionRef.current && mwaThunderstormRef.current && mwaStartDateRef.current && mwaEndDateRef.current && mwaPrevSeaConditionRef.current) {
                        if (item.getProperties()['MIN_WIND']) {
                            mwaMaxWindSpeedRef.current.value = item.getProperties()['MIN_WIND']
                        }
                        if (item.getProperties()['MAX_WIND']) {
                            mwaMaxWindSpeedRef.current.value = item.getProperties()['MAX_WIND']
                        }
                        if (item.getProperties()['MIN_WAVE_HEIGHT']) {
                            mwaMinWaveHeightRef.current.value = item.getProperties()['MIN_WAVE_HEIGHT']
                        }
                        if (item.getProperties()['MAX_WAVE_HEIGHT']) {
                            mwaMaxWaveHeightRef.current.value = item.getProperties()['MAX_WAVE_HEIGHT']
                        }
                        if (item.getProperties()['PREV_SEA_CONDITION']) {
                            mwaPrevSeaConditionRef.current.value = item.getProperties()['PREV_SEA_CONDITION']
                        }
                        if (item.getProperties()['SEA_CONDITION']) {
                            mwaSeaConditionRef.current.value = item.getProperties()['SEA_CONDITION']
                        }
                        if (item.getProperties()['THUNDERSTORM']) {
                            mwaThunderstormRef.current.value = item.getProperties()['THUNDERSTORM']
                        }
                        if (item.getProperties()['START_DATE']) {
                            mwaStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            mwaEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'HWN':
                    if (props.setData && hwnMinWindSpeedRef.current && hwnMaxWindSpeedRef.current && hwnSeverityLevelRef.current && hwnLightningRef.current && hwnStartDateRef.current && hwnEndDateRef.current && hwnPrevSeverityLevelRef.current) {
                        if (item.getProperties()['MIN_WIND']) {
                            hwnMinWindSpeedRef.current.value = item.getProperties()['MIN_WIND']
                        }
                        if (item.getProperties()['MAX_WIND']) {
                            hwnMaxWindSpeedRef.current.value = item.getProperties()['MAX_WIND']
                        }
                        if (item.getProperties()['PREV_SEVERITY']){
                            hwnPrevSeverityLevelRef.current.value = item.getProperties()['PREV_SEVERITY']
                        }
                        if (item.getProperties()['SEVERITY']) {
                            hwnSeverityLevelRef.current.value = item.getProperties()['SEVERITY']
                        }
                        if (item.getProperties()['LIGHTNING']) {
                            hwnLightningRef.current.value = item.getProperties()['LIGHTNING']
                        }
                        if (item.getProperties()['START_DATE']) {
                            hwnStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            hwnEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'LIG':
                    if (props.setData && ligPervAlertLevelRef.current && ligNewAlertLevelRef.current && ligLightingRiskLevelRef.current && ligStartDateRef.current && ligEndDateRef.current) {
                        if (item.getProperties()['PREV_ALERT']) {
                            ligPervAlertLevelRef.current.value = item.getProperties()['PREV_ALERT']
                        }
                        if (item.getProperties()['NEW_ALERT']) {
                            ligNewAlertLevelRef.current.value = item.getProperties()['NEW_ALERT']
                        }
                        if (item.getProperties()['LIGHTNING_RISK']) {
                            ligLightingRiskLevelRef.current.value = item.getProperties()['LIGHTNING_RISK']
                        }
                        if (item.getProperties()['START_DATE']) {
                            ligStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            ligEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'LSW':
                    if (lswPervAlertLevelRef.current && lswNewAlertLevelRef.current && lswRainfallValueRef.current && lswLightingRiskLevelRef.current && lswStartDateRef.current && lswEndDateRef.current) {
                        if (item.getProperties()['PREV_ALERT']) {
                            lswPervAlertLevelRef.current.value = item.getProperties()['PREV_ALERT']
                        }
                        if (item.getProperties()['NEW_ALERT']) {
                            lswNewAlertLevelRef.current.value = item.getProperties()['NEW_ALERT']
                        }
                        if (item.getProperties()['RAINFALL']) {
                            lswRainfallValueRef.current.value = item.getProperties()['RAINFALL']
                        }
                        if (item.getProperties()['LIGHTNING_RISK']) {
                            lswLightingRiskLevelRef.current.value = item.getProperties()['LIGHTNING_RISK']
                        }
                        if (item.getProperties()['START_DATE']) {
                            lswStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            lswEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'NTW':
                    if (props.setData && ntwStartDateRef.current && ntwEndDateRef.current) {
                        if (item.getProperties()['START_DATE']) {
                            ntwStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            ntwEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'ASW':
                    if (props.setData && aswStartDateRef.current && aswEndDateRef.current) {
                        if (item.getProperties()['START_DATE']) {
                            aswStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            aswEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'TW':
                    if (props.setData && twMinWindSpeedRef.current && twMaxWindSpeedRef.current && twMinWaveHeightRef.current && twMaxWaveHeightRef.current && twSeaConditionRef.current && twThunderstormRef.current && twStartDateRef.current && twEndDateRef.current && mwaPrevSeaConditionRef.current) {
                        if (item.getProperties()['MIN_WIND']) {
                        twMaxWindSpeedRef.current.value = item.getProperties()['MIN_WIND']
                        }
                        if (item.getProperties()['MAX_WIND']) {
                            twMaxWindSpeedRef.current.value = item.getProperties()['MAX_WIND']
                        }
                        if (item.getProperties()['MIN_WAVE_HEIGHT']) {
                            twMinWaveHeightRef.current.value = item.getProperties()['MIN_WAVE_HEIGHT']
                        }
                        if (item.getProperties()['MAX_WAVE_HEIGHT']) {
                            twMaxWaveHeightRef.current.value = item.getProperties()['MAX_WAVE_HEIGHT']
                        }
                        if (item.getProperties()['PREV_SEA_CONDITION']) {
                            mwaPrevSeaConditionRef.current.value = item.getProperties()['PREV_SEA_CONDITION']
                        }
                        if (item.getProperties()['SEA_CONDITION']) {
                            twSeaConditionRef.current.value = item.getProperties()['SEA_CONDITION']
                        }
                        if (item.getProperties()['THUNDERSTORM']) {
                            twThunderstormRef.current.value = item.getProperties()['THUNDERSTORM']
                        }
                        if (item.getProperties()['START_DATE']) {
                            twStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            twEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
                case 'CUS':
                    if (props.setData && cusSeverityLevelRef.current&& cusStartDateRef.current && cusEndDateRef.current && cusPrevSeverityLevelRef.current) {
                        if (item.getProperties()['SEVERITY']) {
                            cusSeverityLevelRef.current.value = item.getProperties()['SEVERITY']
                        }
                        if (item.getProperties()['START_DATE']) {
                            cusStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            cusEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                        if (item.getProperties()['PREV_SEVERITY']){
                            cusPrevSeverityLevelRef.current.value = item.getProperties()['PREV_SEVERITY']
                        }
                    }
                    break
                case 'GUS':
                    if (props.setData && gusMinWindSpeedRef.current && gusMaxWindSpeedRef.current && gusSeverityLevelRef.current && gusLightningRef.current && gusStartDateRef.current && gusEndDateRef.current && gusPrevSeverityLevelRef.current) {
                        if (item.getProperties()['MIN_WIND']) {
                            gusMinWindSpeedRef.current.value = item.getProperties()['MIN_WIND']
                        }
                        if (item.getProperties()['MAX_WIND']) {
                            gusMaxWindSpeedRef.current.value = item.getProperties()['MAX_WIND']
                        }
                        if (item.getProperties()['PREV_SEVERITY']){
                            gusPrevSeverityLevelRef.current.value = item.getProperties()['PREV_SEVERITY']
                        }
                        if (item.getProperties()['SEVERITY']) {
                            gusSeverityLevelRef.current.value = item.getProperties()['SEVERITY']
                        }
                        if (item.getProperties()['LIGHTNING']) {
                            gusLightningRef.current.value = item.getProperties()['LIGHTNING']
                        }
                        if (item.getProperties()['START_DATE']) {
                            gusStartDateRef.current.value = item.getProperties()['START_DATE']
                        }
                        if (item.getProperties()['END_DATE']) {
                            gusEndDateRef.current.value = item.getProperties()['END_DATE']
                        }
                    }
                    break
            }
        })
        
    }, [])

    return (
        <div className='map-selector-popup'>
            <div className='msp-popup-data-wrapper'>
                <span className='msp-title'>warning data - Multiple Locations<div onClick={handleClose}><CloseIcon width='1rem' color='var(--color-text)'/></div></span>
                
                {props.type === 'HRW' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={hrwPervAlertLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {hrwPrevAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>New Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={hrwNewAlertLevelRef}>
                                    <option value="">No alert</option>
                                    {hrwNewAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Rainfall (mm)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={hrwRainfallValueRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Lightning Risk Level</span>
                            <div className='msp-selector-values'>
                                <select ref={hrwLightingRiskLevelRef}>
                                    <option value="">No alert</option>
                                    {hrwLightingRiskLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.startDate} ref={hrwStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.endDate} ref={hrwEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'LSW' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={lswPervAlertLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {lswPrevAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>New Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={lswNewAlertLevelRef}>
                                    <option value="">No alert</option>
                                    {lswNewAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Rainfall (mm)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={lswRainfallValueRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Lighting Risk Level</span>
                            <div className='msp-selector-values'>
                                <select ref={lswLightingRiskLevelRef}>
                                    <option value="">No alert</option>
                                    {lswLightingRiskLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.startDate} ref={lswStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.endDate} ref={lswEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'FLW' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={flwPervAlertLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {flwPrevAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>New Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={flwNewAlertLevelRef}>
                                    <option value="">No alert</option>
                                    {flwNewAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Rainfall (mm)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={flwRainfallValueRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Next Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={flwLightingRiskLevelRef}>
                                    <option value="">No alert</option>
                                    {flwLightingRiskLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.startDate} ref={flwStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.endDate} ref={flwEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'LIG' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={ligPervAlertLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {ligPreviousAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>New Alert Level</span>
                            <div className='msp-selector-values'>
                                <select ref={ligNewAlertLevelRef}>
                                    <option value="">No alert</option>
                                    {ligNewAlertLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Lightning Risk Level</span>
                            <div className='msp-selector-values'>
                                <select ref={ligLightingRiskLevelRef}>
                                    <option value="">No alert</option>
                                    {ligLightningRiskLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.startDate} ref={ligStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type='datetime-local' defaultValue={props.endDate} ref={ligEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'HWN' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Min Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={hwnMinWindSpeedRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Max Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={hwnMaxWindSpeedRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Severity</span>
                            <div className='msp-selector-values'>
                                <select ref={hwnPrevSeverityLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {hwnSeverityLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Severity</span>
                            <div className='msp-selector-values'>
                                <select ref={hwnSeverityLevelRef}>
                                    <option value="">No alert</option>
                                    {hwnSeverityLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Lighting</span>
                            <div className='msp-selector-values'>
                                <select ref={hwnLightningRef}>
                                    <option value="">No alert</option>
                                    {hwnLightning.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={hwnStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={hwnEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'MWA' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Min Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={mwaMinWindSpeedRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Max Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={mwaMaxWindSpeedRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Min Wave Height (m)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={mwaMinWaveHeightRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Max Wave Height (m)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={mwaMaxWaveHeightRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Sea Condition</span>
                            <div className='msp-selector-values'>
                                <select ref={mwaPrevSeaConditionRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {mwaSeaCondition.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Sea Condition</span>
                            <div className='msp-selector-values'>
                                <select ref={mwaSeaConditionRef}>
                                    <option value="">No alert</option>
                                    {mwaSeaCondition.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Thunderstorm</span>
                            <div className='msp-selector-values'>
                                <select ref={mwaThunderstormRef}>
                                    <option value="">No alert</option>
                                    {mwaThunderstorm.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={mwaStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={mwaEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'NTW' && (
                    <div className='msp-data-wrapper'>
                        
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={mwaStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={mwaEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'ASW' && (
                    <div className='msp-data-wrapper'>
                        
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={mwaStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={mwaEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'TW' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Min Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={twMinWindSpeedRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Max Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={twMaxWindSpeedRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Min Wave Height (m)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={twMinWaveHeightRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Max Wave Height (m)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={twMaxWaveHeightRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Sea Condition</span>
                            <div className='msp-selector-values'>
                                <select ref={twPrevSeaConditionRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {twSeaCondition.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Sea Condition</span>
                            <div className='msp-selector-values'>
                                <select ref={twSeaConditionRef}>
                                    <option value="">No alert</option>
                                    {twSeaCondition.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Thunderstorm</span>
                            <div className='msp-selector-values'>
                                <select ref={twThunderstormRef}>
                                    <option value="">No alert</option>
                                    {twThunderstorm.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={twStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={twEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'CUS' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Severity</span>
                            <div className='msp-selector-values'>
                                <select ref={cusPrevSeverityLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {cusSeverityLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Severity</span>
                            <div className='msp-selector-values'>
                                <select ref={cusSeverityLevelRef}>
                                    <option value="">No alert</option>
                                    {cusSeverityLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={cusStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={cusEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}

                {props.type === 'GUS' && (
                    <div className='msp-data-wrapper'>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Min Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={gusMinWindSpeedRef}/>
                            </div>
                        </div>

                        <div className='selector-container'>
                            <span className='msp-selector-title'>Max Wind Speed (kmph)</span>
                            <div className='msp-selector-values'>
                                <input type="number" defaultValue={0} min={0} ref={gusMaxWindSpeedRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Previous Severity</span>
                            <div className='msp-selector-values'>
                                <select ref={gusPrevSeverityLevelRef} disabled={true}>
                                    <option value="">No alert</option>
                                    {gusSeverityLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Severity</span>
                            <div className='msp-selector-values'>
                                <select ref={gusSeverityLevelRef}>
                                    <option value="">No alert</option>
                                    {gusSeverityLevel.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Lighting</span>
                            <div className='msp-selector-values'>
                                <select ref={gusLightningRef}>
                                    <option value="">No alert</option>
                                    {gusLightning.map((item, index) => (
                                        <option key={index} value={item.value}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>Start Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.startDate} ref={hwnStartDateRef}/>
                            </div>
                        </div>
                        <div className='selector-container'>
                            <span className='msp-selector-title'>End Date</span>
                            <div className='msp-selector-values'>
                                <input type="datetime-local" defaultValue={props.endDate} ref={hwnEndDateRef}/>
                            </div>
                        </div>
                        <div className='msp-button-container'>
                            {/* <button>analyze from global weather forecast</button> */}
                            <button onClick={handleReset}>reset</button>
                            <button onClick={() => handleSaveButtonClick(props.type)}>save</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default MapSelectorPolygonPopup